/* -------------- Operation based interfaces -------------- */

// LIST
export interface DocumentListItem {
    id?: string;
    categoryName: string;
    displayOrder: number;
    name: string;
    url: string;
    size: number;
    mimeType: string;
    extension: string;
    creationDate: string;
}

export interface DocumentListApiResponse {
    result: {
        items: DocumentListItem[];
    };
    error: string | null;
    isSuccessful: boolean;
}

// GET
export interface DocumentDetail {
    id: string;
    categoryName: string;
    displayOrder: number;
    url: string;
    name: string;
    size: number;
    mimeType: string;
    extension: string;
    creationDate: string;
}

export interface DocumentGetApiResponse {
    result: {
        id: string;
        categoryName: string;
        displayOrder: number;
        url: string;
        name: string;
        size: number;
        mimeType: string;
        extension: string;
        creationDate: string;
    }
    error: string | null;
    isSuccessful: boolean;
}

// ADD
export interface DocumentAddData {
    categoryId: string;
    documents: File[];
    documentName?: string;
    displayOrder?: number;
}

export const defaultDocumentAddData: DocumentAddData = {
	categoryId: "",
	documents: [],
	documentName: "",
	displayOrder: undefined
};

// UPDATE
export interface DocumentUpdateData {
    documentId: string;
    documentName?: string;
    displayOrder?: number;
    document?: File | null;
}

export const defaultDocumentUpdateData: DocumentUpdateData = {
	documentId: "",
	documentName: "",
	document: null,
	displayOrder: undefined
};

// Page States
export type OperationStatus =
    | { type: "idle" }
    | { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
    | { type: "error"; operation: string; message: string };